import NameLinkCell from '@/components/NameLinkCell';
import type { SampleWithNamesPublic } from '@/types';
import React, { type FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

export interface InstrumentRunCellRendererProps {
  className?: string;
  data?: SampleWithNamesPublic;
  fullHeight?: boolean;
}

const InstrumentRunCellRendererComponent: FC<InstrumentRunCellRendererProps> = ({ className, data, fullHeight }) => {
  const { t } = useTranslation('studies');

  if (!data) return null;

  return (
    <NameLinkCell
      ariaLabel={t('goToInstrumentRun')}
      className={className}
      fullHeight={fullHeight}
      id={data.instrument_run_id}
      name={data.instrument_run_name}
      params={{ instrumentRunId: String(data.instrument_run_id) }}
      testId="instrument-run-link-button"
      to="/instrument_runs/$instrumentRunId"
    />
  );
};

export const InstrumentRunCellRenderer = memo(InstrumentRunCellRendererComponent);

export default InstrumentRunCellRenderer;
